import { ColsGroupedDataType } from 'app/dataTypes/reports/data/common/subsidies/grouped'
import { Entity } from './types'

export const createDynamicColumnKey = (classType: 'dayCares' | 'klasses', title: string) => {
  return `${classType}_${title}`
}

export const createDynamicCountSumKey = (classType: 'dayCares' | 'klasses', title: string, type: 'count' | 'sum') => {
  return `${classType}_${title}_${type}`
}

export const extractDateFromColumnKey = (columnKey: string) => {
  return columnKey.replace(`${Entity.Date}_`, '')
}

export const columnKeysLeft = [Entity.Date]
export const columnKeysLeftHeaders = [columnKeysLeft, [Entity.DateGhost], [Entity.DateGhost]]
export const columnKeysRight = [Entity.CountRow, Entity.SumRow]
export const columnKeysRightHeaders = [[Entity.TotalRow], [Entity.TotalRowGhost], columnKeysRight]

export const createColumnKeysMain = (cols: ColsGroupedDataType) => {
  return [
    ...cols.dayCares.flatMap((dayCare) => [
      createDynamicCountSumKey('dayCares', dayCare, 'count'),
      createDynamicCountSumKey('dayCares', dayCare, 'sum'),
    ]),
    ...cols.klasses.flatMap((klass) => [
      createDynamicCountSumKey('klasses', klass, 'count'),
      createDynamicCountSumKey('klasses', klass, 'sum'),
    ]),
  ]
}

export const createColumnKeysMainHeaders = (cols: ColsGroupedDataType) => {
  const topRow = [
    ...(cols.dayCares.length ? [Entity.DayCares] : []),
    ...(cols.klasses.length ? [Entity.Klasses] : []),
  ]

  return [
    topRow,
    [
      ...cols.dayCares.map((title) => createDynamicColumnKey('dayCares', title)),
      ...cols.klasses.map((title) => createDynamicColumnKey('klasses', title)),
    ],
    [
      ...cols.dayCares.flatMap((title) => [
        createDynamicCountSumKey('dayCares', title, 'count'),
        createDynamicCountSumKey('dayCares', title, 'sum'),
      ]),
      ...cols.klasses.flatMap((title) => [
        createDynamicCountSumKey('klasses', title, 'count'),
        createDynamicCountSumKey('klasses', title, 'sum'),
      ]),
    ],
  ]
}
